module.exports = __webpack_public_path__ + "assets/img/default.57334262.png";